import { CalendarIcon, MoneysIcon, PercentageSquareIcon } from "icons/outline";
import EntityCard from "../EntityCard";
import Link from "next/link";

export default function PlanCard({ data, link }) {
  const {
    id,
    title,
    pricing: { amount, currency, recurrency, recurrency_unit },
  } = data;

  return (
    <EntityCard
      icon={<PercentageSquareIcon className="h-5 w-5" />}
      imageDimensions={72}
      subTitle={"Plan"}
      title={title}
      id={id}
      primaryAction={
        <EntityCard.PrimaryButton render={<Link href={link} />}>
          View plan
        </EntityCard.PrimaryButton>
      }
    >
      <div className="flex items-center gap-2 text-sm font-medium text-foundations-subtle md:py-[7px]">
        <div className="flex items-center gap-2">
          <MoneysIcon
            width={16}
            height={16}
            className="shrink-0 text-foundations-subtler"
          />

          <span className="whitespace-nowrap">
            {amount} {currency},
          </span>
        </div>

        <div className="flex items-center gap-2">
          <CalendarIcon
            width={16}
            height={16}
            className="shrink-0 text-foundations-subtler"
          />

          <span className="line-clamp-1 text-ellipsis capitalize">
            {recurrency} {recurrency_unit?.toLowerCase()}
          </span>
        </div>
      </div>
    </EntityCard>
  );
}
